import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { setAlert, setProcessingFollow, updateCcVerification } from '../../../redux/actions';
import CloseButton from '../CloseButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import './style.scss';

const VerifyModal = ({
    show,
    setShow,
    setVerifyStatus = () => ({})
}) => {
    const dispatch = useDispatch();

    const [error, setError] = useState('');
    const [chargeAmount, setChargeAmount] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [currency, setCurrency] = useState('');

    const getCurrency = async () => {
        await axios.get('/api/transactions/currency')
            .then((response) => {
                setCurrency(response.data.currency);
            });
    };

    useEffect(() => {
        getCurrency();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (chargeAmount <= 0) {
            setError('Please enter a valid amount');
            return false;
        }

        setError('');
        setIsLoading(true);
        await axios.post('/api/cards/verify', {
            amount: chargeAmount
        })
            .then(response => {
                dispatch(setAlert({
                    show: true,
                    title: '',
                    body: 'Thank you for verifying your card payment account.',
                    type: 'success'
                }));
                dispatch(updateCcVerification({
                    showVerify: false
                }));
                setIsLoading(false);
                setVerifyStatus(true);
            }).catch(err => {
                console.error({ err });
                setIsLoading(false);
                if (err.response && err.response.status && err.response.status === 422) {
                    const responseData = err.response.data;
                    const firstErrorKey = Object.keys(responseData.errors);
                    setError(responseData.errors[firstErrorKey][0] || 'Unable to verify account');
                } else if (err.response && err.response.status && err.response.status === 404) {
                    setError('Card not found');
                } else if (err.response && err.response.status && err.response.status === 400) {
                    dispatch(setAlert({
                        show: true,
                        title: '',
                        body: 'Maximum attempts reached.<br />Please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.',
                        type: 'error'
                    }));
                } else {
                    dispatch(setAlert({
                        show: true,
                        title: '',
                        body: 'Unable to verify card.<br />Please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.',
                        type: 'error'
                    }));
                }
            });
    };

    const handleKeypress = (e) => {
        if (!((e.keyCode > 95 && e.keyCode < 106)
            || (e.keyCode > 47 && e.keyCode < 58)
            || e.keyCode == 8 || e.keyCode == 190 || e.keyCode == 194 || e.keycode == 108 || e.keyCode == 110)) {
            e.preventDefault(); // Let's stop this event.
            e.stopPropagation(); // Really this time.
            return false;
        }
    };

    const handleChange = (e) => {
        if (!e.target.value || e.target.value <= 0) {
            setError('Please enter a valid amount');
        } else {
            setError('');
        }
        setChargeAmount(e.target.value);
    };

    const handleHide = () => {
        dispatch(setProcessingFollow(false));
        setError('');
        setChargeAmount('');
        dispatch(updateCcVerification({
            showVerify: false
        }));
    };


    return (
        <React.Fragment>

            <Dialog
                className='modal-ppv-price'
                open={show}
                onClose={handleHide}
            >
                <DialogContent>
                    <div className="text-center sendtip-wrapper verify">
                        <CloseButton
                            className='close'
                            onClick={handleHide}
                            style={{ position: 'absolute', top: '12px', right: '12px' }}
                        />
                        <h6>Verify Account Card Payment</h6>
                        <p>
                            Please enter the {currency} currency amount that was just charged to your card:
                        </p>
                        <form id="sendtipform" method="post" onSubmit={handleSubmit}>
                            <div className="cent-in">
                                <div className={`form-group${error ? ' has-validation' : ''}`}>
                                    <span className="input-icon"><FontAwesomeIcon icon={['fas', 'dollar-sign']} /></span>
                                    <input
                                        type="number"
                                        className={`form-control${error ? ' error' : ''}`}
                                        id="chargeAmount"
                                        name="amount"
                                        autoComplete="off"
                                        placeholder={`Enter ${currency} Amount`}
                                        onChange={handleChange}
                                        onKeyDown={handleKeypress}
                                        value={chargeAmount}
                                        inputMode="decimal"
                                        step="0.01"
                                    />
                                    {error && <label
                                        htmlFor="chargeAmount"
                                        generated="true"
                                        className="invalid-feedback error"
                                        style={{ display: 'block', fontSize: '16px', color: 'red' }}
                                    >
                                        {error}
                                    </label>}
                                </div>

                                <p>
                                    The charge will appear in your bank statement as Privaposts.
                                </p>

                                <p>
                                    You can find the amount charged with your mobile banking app, or with your online banking transactions summary page.
                                </p>
                                <div className="text-left">
                                    If you're currently using a:
                                    <ul className='payment-type'>
                                        <li>
                                            <strong>Debit card</strong><br />
                                            The tiny amount should be reimbursed immediately. However, in rare instances, it may take longer for those tiny amounts to come through depending on your financial institution.
                                        </li>
                                        <li>
                                            <strong>Credit card</strong><br />
                                            The tiny amount will be placed under a pending status. The transaction will not be charged to your account however depending on your financial institution it may take a few days to come out of a pending status.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="btns clearfix">
                                <button type="submit" className="btn btn-default sendtip blue-btn-hover" disabled={isLoading || error}>
                                    {isLoading ? 'Verifying...' : 'Verify'}
                                </button>
                            </div>
                        </form>
                    </div>
                </DialogContent>
            </Dialog>
            {/* <Modal
                className="sendtip-modal"
                show={show}
                onHide={handleHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className="text-center sendtip-wrapper verify">
                        <CloseButton
                            className='close'
                            onClick={handleHide}
                            style={{ position: 'absolute', top: '12px', right: '12px' }}
                        />
                        <h6>Verify Account Card Payment</h6>
                        <p>
                            Please enter the {currency} currency amount that was just charged to your card:
                        </p>
                        <form id="sendtipform" method="post" onSubmit={handleSubmit}>
                            <div className="cent-in">
                                <div className={`form-group${error ? ' has-validation' : ''}`}>
                                    <span className="input-icon"><FontAwesomeIcon icon={['fas', 'dollar-sign']} /></span>
                                    <input
                                        type="number"
                                        className={`form-control${error ? ' error' : ''}`}
                                        id="chargeAmount"
                                        name="amount"
                                        autoComplete="off"
                                        placeholder={`Enter ${currency} Amount`}
                                        onChange={handleChange}
                                        onKeyDown={handleKeypress}
                                        value={chargeAmount}
                                        inputMode="decimal"
                                        step="0.01"
                                    />
                                    {error && <label
                                        htmlFor="chargeAmount"
                                        generated="true"
                                        className="invalid-feedback error"
                                        style={{ display: 'block', fontSize: '16px', color: 'red' }}
                                    >
                                        {error}
                                    </label>}
                                </div>

                                <p>
                                    The charge will appear in your bank statement as Privaposts.
                                </p>

                                <p>
                                    You can find the amount charged with your mobile banking app, or with your online banking transactions summary page.
                                </p>
                                <div className="text-left">
                                    If you're currently using a:
                                    <ul className='payment-type'>
                                        <li>
                                            <strong>Debit card</strong><br />
                                            The tiny amount should be reimbursed immediately. However, in rare instances, it may take longer for those tiny amounts to come through depending on your financial institution.
                                        </li>
                                        <li>
                                            <strong>Credit card</strong><br />
                                            The tiny amount will be placed under a pending status. The transaction will not be charged to your account however depending on your financial institution it may take a few days to come out of a pending status.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="btns clearfix">
                                <button type="submit" className="btn btn-default sendtip blue-btn-hover" disabled={isLoading || error}>
                                    {isLoading ? 'Verifying...' : 'Verify'}
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal> */}
        </React.Fragment>
    );
};

export default VerifyModal;
